@if (!isLoadingUiActive() && !showTimerError && !showAlmostThere) {
<app-header [pageTitle]="pageTitle" (click)="lostLuckyNumbers()" class="syndicate-ticket-header"></app-header>
}



<ion-content scroll-y="false">
  @if (ticketData) {
  <div class="page-background-blue upper-content-wrap">
    @if (!isLoadingUiActive() && !showTimerError && !showAlmostThere) {
    <div class="heading-wrapper">
      <div class="header-container">
        <h1 class="header-text heading-tickets">{{ "syndicate-tickets.ticket" | translate }} </h1>
        <h1 class="txt-clr-light-blue syndicate-name">
          {{ ("syndicate-tickets.name" | translate) + " " + syndicate_name() }}
        </h1>
      </div>
      @if (syndicate?.offer_type !== 'custom_lottery' && syndicateDetails?.syndicate_type=='Ongoing') {
      <div class="fun-container">
        @if (luckyNumbersEnabledData?.lucky_numbers && remainingData) {
        <mat-icon matTooltipClass="star-component" class="star-tooltip" #startip="matTooltip"
          [matTooltip]="luckyNumberTooltip" matTooltipPosition="below"
          [matTooltipDisabled]="!syndicateDetails?.active_product_count" (click)="enableLuckyNum()">
          <div class="star">
            <div class="icon-con"
              [ngClass]="remainingData && !goldRingFeatureDisplay ? 'icon-con' : 'disable-icon-con'">
              <img [src]="
                  remainingData && !goldRingFeatureDisplay ? '../../../../assets/icon/star_icon.png' : '../../../../assets/icon/star_icon_gray.png'
                " alt="star" />
            </div>
            <span>{{ remainingData }}</span>
          </div>
        </mat-icon>
        }
        @if (luckyNumbersEnabledData?.lucky_numbers && !remainingData) {
        <div class="star">
          <div class="icon-con" [ngClass]="remainingData && !goldRingFeatureDisplay ? 'icon-con' : 'disable-icon-con'">
            <img [src]="
                remainingData && !goldRingFeatureDisplay ? '../../../../assets/icon/star_icon.png' : '../../../../assets/icon/star_icon_gray.png'
              " alt="star" />
          </div>
          <span [ngClass]="{'mute-text' : goldRingFeatureDisplay} ">{{ remainingData }}</span>
        </div>
        }
        @if (luckyNumbersEnabledData?.gold_rings && syndicateDetails?.syndicate_type == 'Ongoing' &&
        syndicateDetails?.active_status=='running') {
        <div class="gold-ring-wrapper" (click)="enableGoldRing()">
          <div class="uparrow">
            <div class="icon-con"
              [ngClass]="goldRingRemainingData && !luckyNumberFeatureDisplay ? 'icon-con' : 'disable-icon-con'">
              <img
                [src]="goldRingRemainingData && !luckyNumberFeatureDisplay ? '../../../../assets/icon/gold_up.png' : '../../../../assets/icon/up_arrow.png'"
                alt="ring" />
            </div>
            <span>{{goldRingRemainingData}}</span>
          </div>
          <div class="tooltip">
            {{goldRingToolTip}}
          </div>
        </div>
        }
      </div>
      }
    </div>
    }
    @if (showTimerError) {
    <div class="timer-error-text">
      {{'syndicate-loading.timer-error-text'|translate}}
      <app-header [pageTitle]="pageTitle" (click)="lostLuckyNumbers()" class="timer-error-header"></app-header>
    </div>
    }
    @if (showAlmostThere && !showTimerError) {
    <div class="timer-error-text almost-there-text">
      {{ almostThereText }}
    </div>
    }
    <!-- <div *ngIf="syndicateDetails?.syndicate_id; else other_content"> -->
    @if (showSlides && !isLoadingUiActive() && !showTimerError && !showAlmostThere) {
    <swiper [config]="getSliderOptions(ticketData?.product)" #syndicateTicketsSlider class="for-status-card"
      (slideChangeTransitionEnd)="slideChanged()">
      @if (ticketData?.product && ticketData?.product?.length) {
      @for (ticket of ticketData?.product; track ticket; let i = $index; let productIndex = $index) {
      <ng-template swiperSlide class="ticketAlign" (touchstart)="onTouchTickits()">
        <!-- Gold Ring status card -->
        <!--  <div class="ticket-notification"> <p>Now you’re ready to confirm</p> <span class="badge">0 Remaining</span></div> -->
        @if (
        showGrStatusCard &&
        luckyNumbersEnabledData?.gold_rings &&
        !ticket?.isExpired &&
        displayGoldRingRemainingData && syndicateDetails?.syndicate_type == 'Ongoing' &&
        syndicateDetails?.active_status=='running'
        ) {
        <div class="ticket-notification">
          @if (!ticket?.selectedGoldRingCount && displayGoldRingRemainingData) {
          <p>{{applyGoldRing}}</p>
          }
          @if (ticket?.selectedGoldRingCount && displayGoldRingRemainingData) {
          <p>{{applyGoldRing}}</p>
          }
          @if (ticket?.selectedGoldRingCount && !displayGoldRingRemainingData) {
          <p>{{confirmGoldRing}}</p>
          }
          <span class="badge">{{ displayGoldRingRemainingData }} {{remaining}}</span>
        </div>
        }
        @if (
        showGrStatusCard &&
        luckyNumbersEnabledData?.gold_rings &&
        !ticket?.isExpired &&
        !displayGoldRingRemainingData
        ) {
        <div class="ticket-notification">
          <p>{{confirmGoldRing}}</p>
          <span class="badge">{{ displayGoldRingRemainingData }} {{remaining}}</span>
        </div>
        }
        <!-- Gold Ring status card -->
        <ion-card class="ticket-card-size" [ngClass]="{
              'status-card-size':
                luckyNumberFeatureDisplay &&
                luckyNumbersEnabledData?.lucky_numbers &&
                !ticket?.isExpired &&
                (displayRemainingData || (ticket?.selectedCount && !displayRemainingData))
            }" [@flipIn]="showFlip">
          <div class="anime">
            @if (showAnim() && ticketData && ticket?.ticketLines && ticket?.ticketLines?.length > 10) {
              <ng-lottie class="lottie-animation" [options]="options" (loopComplete)="onLoopComplete()"></ng-lottie>
            }
          </div>
          @if (
          showStatusCard &&
          luckyNumberFeatureDisplay &&
          luckyNumbersEnabledData?.lucky_numbers &&
          !ticket?.isExpired &&
          displayRemainingData
          ) {
          <div class="ticket-notification">
            @if (!ticket?.selectedCount && displayRemainingData) {
            <p>{{placeLuckyCard}}</p>
            }
            @if (ticket?.selectedCount && displayRemainingData) {
            <p>{{applyLuckyNumber}}</p>
            }
            @if (ticket?.selectedCount && !displayRemainingData) {
            <p>{{confirmLuckyNumber}}</p>
            }
            <span class="badge">{{ displayRemainingData }} {{remaining}}</span>
          </div>
          }
          @if (
          showStatusCard &&
          luckyNumberFeatureDisplay &&
          luckyNumbersEnabledData?.lucky_numbers &&
          !ticket?.isExpired &&
          ticket?.selectedCount &&
          !displayRemainingData
          ) {
          <div class="ticket-notification">
            <p>{{confirmLuckyNumber}}</p>
            <span class="badge">{{ displayRemainingData }} {{remaining}}</span>
          </div>
          }
          <ion-grid [ngClass]="showStatusCard ? 'ticket-card-wrapper-card' : 'ticket-card-wrapper'">
            <ion-row class="jackpot-details-row">
              <ion-col size="1.5" class="jackpot-logo-wrap">
                <img class="jackpot-logo" src="{{ ticket?.image_url }}" alt="product-image" />
              </ion-col>
              <ion-col size="6.5">
                <h3 class="jackpot-name ion-text-left">{{ ('dynamic_value.'+(ticket?.product_name) |
                  translate)?.indexOf('dynamic_value') > -1 ? (ticket?.product_name) :
                  ('dynamic_value.'+(ticket?.product_name) | translate) }}</h3>
                <p class="lines-available ion-text-left">
                  <!-- {{ ticket?.ticket_group?.draw_day }} {{ ticket?.draw_date }} -->
                  <!-- For {{ ticket?.next_draw_date?.toDate() | date: "EEE - MMM d" }} -->
                  {{"syndicate-tickets.For" | translate }} {{
                  ('dynamic_value.' + (ticket?.next_draw_date?.toDate() | date: "EEE") | translate) + ' ' +
                  (ticket?.next_draw_date?.toDate() | date:"dd")
                  + ' ' + (translateMonth(ticket?.next_draw_date?.toDate()) | translate) + ' ' +
                  (ticket?.next_draw_date?.toDate() | date:"yyyy") }}
                </p>
              </ion-col>
              <ion-col size="4" class="jackpot-right-wrap">
                <h1 class="syndicate-name txt-clr-light-blue ion-text-right txt-players">
                  {{ "syndicate-tickets.Share" | translate }}
                </h1>
                @if (viewText && !dotAnimation) {
                <p class="view-players link-text-blue" (click)="viewPlayers(i)">
                  {{ "syndicate-tickets.view" | translate }}
                </p>
                }
                <div id="tooltip-{{ i }}" class="tooltip-wrapper">
                  @if (coachMarkData$ | async; as coachMarkData) {
                  <div class="tooltip-content">
                    <h3 class="tooltip-title">{{coachMarkData?.title}}</h3>
                    <div class="tooltip-desc">{{coachMarkData?.description}}</div>
                  </div>
                  }
                </div>
                @if (!viewText) {
                <p class="player-number">{{ syndicateCount == "0" ? "-" : syndicateCount }}</p>
                }
                @if (dotAnimation) {
                <app-dot-flash-animation></app-dot-flash-animation>
                }
              </ion-col>
            </ion-row>
            @if (ticket?.ticketLines && ticket?.ticketLines?.length) {
            <div class="ticket-number-wrap">
              @for (ticketRow of ticket?.ticketLines; track ticketRow; let i = $index; let oddRow = $odd; let evenRow =
              $even) {
              <ion-row class="ticket-number-row" [ngClass]="{ 'ticket-number-row-opacity': createSyndicate && (i === 2 || i === 3), 'highlighted-row': 
                  ticket?.gold_ring?.lines?.includes(alphabeticOrder(i))}"
                (click)="getSelectedGoldRings(alphabeticOrder(i), ticket)">
                <ion-col class="ion-no-padding" size="1.5">
                  <h1 class="ticket-serial"
                    [ngClass]="{ 'disabled-gr-ticket': syndicateDetails?.syndicate_type!=='Ongoing'|| syndicateDetails?.active_status!=='running' || !goldRingFeatureDisplay || (!displayGoldRingRemainingData && !ticket?.isExpired) }">
                    {{ alphabeticOrder(i) }}</h1>
                </ion-col>
                @if (showLines) {
                @for (mainNumber of ticketRow?.regularNumbers; track mainNumber; let colIndex = $index) {
                <ion-col class="ion-no-padding" [ngClass]="{ 'background-color': oddRow && checkedTicket }">
                  @if (luckyNumberFeatureDisplay && !goldRingFeatureDisplay) {
                  <h1 [ngClass]="{
                            'color-bg': getSelectedTicketAfterSave(
                              mainNumber,
                              i,
                              productIndex,
                              ticket?.id,
                              ticket?.next_draw_date?.toDate() | date: 'yyyy-MM-dd',
                              ticket?.selected_numbers
                            ),
                            'gray-bg': displayRemainingData && !ticket?.isExpired
                          }" class="ticket-number {{ disabledLNStyle }}"
                    (click)="getSelectedTicket($event, mainNumber, i, productIndex, ticket?.id)"
                    id="tkt-num-id-{{ productIndex }}-{{ i }}-{{ mainNumber }}">
                    {{ mainNumber }}
                  </h1>
                  }
                  @if (!luckyNumberFeatureDisplay && ticket?.selected_numbers) {
                  <h1 [ngClass]="{
                            'color-bg': getSelectedTicketAfterSave(
                              mainNumber,
                              i,
                              productIndex,
                              ticket?.id,
                              ticket?.next_draw_date?.toDate() | date: 'yyyy-MM-dd',
                              ticket?.selected_numbers
                            )
                          }" class="ticket-number {{ disabledLNStyle }}"
                    id="tkt-num-id-{{ productIndex }}-{{ i }}-{{ mainNumber }}">
                    {{ mainNumber }}
                  </h1>
                  }
                  <!-- <h1 *ngIf="!isGRAlreadySelected(alphabeticOrder(i)) && !displayGoldRingRemainingData && !ticket?.isExpired" class="ticket-number {{ disabledGRStyle }}">
                                      {{ mainNumber }}
                                    </h1> -->
                  @if (!luckyNumberFeatureDisplay && !ticket?.selected_numbers) {
                  <h1 class="ticket-number"
                    [ngClass]="{'disabled-color': disableGRLine(alphabeticOrder(i), productIndex) }">
                    {{ mainNumber }}
                  </h1>
                  }
                </ion-col>
                }
                @for (bonusNumber of ticketRow?.bonusNumbers; track bonusNumber; let odd = $odd; let yellowIndex =
                $index) {
                <ion-col class="ion-no-padding" [ngClass]="{ 'background-color': oddRow && checkedTicket }">
                  <h1 class="ticket-number golden-ticket-number">
                    {{ bonusNumber }}
                  </h1>
                </ion-col>
                }
                }
                @if (!showLines) {
                <ion-col size="9" class="ion-no-padding">
                  <h1 class="ticket-number-raffel">{{ ticketRow?.raffle }}</h1>
                </ion-col>
                }
                @if (ticketRow?.eye) {
                <ion-col class="ion-no-padding">
                  <ion-icon name="eye" class="ticket-camera-icon" (click)="setTicket(ticketRow?.eye)"></ion-icon>
                  <!-- <file-preview file="{{ ticketImageURL }}"></file-preview> -->
                </ion-col>
                }
              </ion-row>
              }
              <!-- <img class="hidden-element" (load)="previewTicket()" src="{{ ticketImageURL }}" alt="ticketImage" /> -->
            </div>
            }
            <div class="ticket-footer-content">
              <div class="ticket-section">
                <ion-row class="total-lines-wrapper">
                  <ion-col>
                    <p class="total-lines">{{ "syndicate-tickets.Total Line(s)" | translate }}</p>
                  </ion-col>
                  <ion-col>
                    <p class="no-of-lines">{{ ticket?.total_lines }} {{ "syndicate-tickets.line(s)" | translate }}</p>
                  </ion-col>
                </ion-row>
                @if (
                luckyNumberFeatureDisplay && !ticket?.isExpired && remainingData) {
                <ion-row class="choose-btn-container">
                  <div class="choose-btn">
                    <button [ngClass]="ticket?.selectedCount ? 'blue' : 'gray'" class="button"
                      (click)="openConfirmPopup()" [disabled]="!ticket?.selectedCount" id="btn-done-{{ productIndex }}">
                      {{doneButton}}
                    </button>
                  </div>
                </ion-row>
                } @else {
                @if (goldRingFeatureDisplay && !ticket?.isExpired && goldRingRemainingData &&
                syndicateDetails?.syndicate_type == 'Ongoing' && syndicateDetails?.active_status=='running') {
                <ion-row class="choose-btn-container">
                  <div class="choose-btn">
                    <button [ngClass]="ticket?.selectedGoldRingCount ? 'blue' : 'gray'" class="button"
                      (click)="confirmGoldRingSelection()" [disabled]="!ticket?.selectedGoldRingCount">
                      {{confirmBtn}}
                    </button>
                  </div>
                </ion-row>
                } @else {
                @if (ticket?.raffle && isRaffleAvailable(i)) {
                <ion-row class="ticker-viwe-million">
                  @if (showLines) {
                  <p class="view-millionaire-makers" (click)="switchMode(true)">
                    {{ "syndicate-tickets.View Millionaire" | translate }}
                  </p>
                  }
                  @if (!showLines) {
                  <p class="view-millionaire-makers" (click)="switchMode(false)">
                    {{ "syndicate-tickets.View lines" | translate }}
                  </p>
                  }
                </ion-row>
                }
                }
                }
              </div>
              <!-- <div *ngIf="ticketChecked" class="ticket-checked-wrap">
                        <p class="ticket-checked-ic">👏🏼</p>
                        <p class="ticket-checked">Ticket already checked</p>
                      </div>
                      <div *ngIf="!ticketChecked" class="ticket-checked-wrap">
                        <p class="ticket-checked-ic">🤞</p>
                        <p class="ticket-checked">Ticket ready to be checked</p>
                      </div> -->
            </div>
          </ion-grid>
        </ion-card>
      </ng-template>
      }
      }
      @if (!ticketData?.product && !ticketData?.product?.length) {
      <div class="no-ticket-wrapper">
        <span class="magnifying-emoji">🔎</span>
        <p>
          {{ "syndicate-tickets.no tickets" | translate }}<br />{{ "syndicate-tickets.error" | translate }}
          <span class="link-text-blue" (click)="openHelpTab()"> {{ "syndicate-tickets.support" | translate }}</span>
        </p>
      </div>
      }
    </swiper>
    }
    @if (!isLoadingUiActive() && !showTimerError && !showAlmostThere) {
    <ion-row [ngClass]="ticketData?.product?.length == 1 ? 'pageButton_' : 'pageButton'">
      <ion-col sizeSm="4" sizeLg="4.7" class="cardPager">
        <button (click)="slidePrev()" class="nav-prev-icon">
          <ion-icon name="chevron-back-outline"></ion-icon>
        </button>
      </ion-col>
      <ion-col sizeSm="2" sizeLg="3" class="cardPager">
        <div class="swiper-pager"></div>
      </ion-col>
      <ion-col sizeSm="6" sizeLg="4.3" class="cardPager">
        <button (click)="slideNext()" class="nav-next-icon">
          <ion-icon name="chevron-forward-outline"></ion-icon>
        </button>
      </ion-col>
    </ion-row>
    }
  </div>
  } @else if (!isLoadingUiActive() && (showAlmostThere || showTimerError)) {
  <div class="page-background-blue upper-content-wrap">
    @if (showTimerError) {
    <div class="timer-error-text">
      {{'syndicate-loading.timer-error-text'|translate}}
    </div>
    }
    @if (showAlmostThere && !showTimerError) {
    <div class="timer-error-text almost-there-text">
      {{ almostThereText }}
    </div>
    }
  </div>
  } @else if (!isLoadingUiActive()) {
  <app-in-progress-animation></app-in-progress-animation>
  }
  <ng-template #loading>
    <app-in-progress-animation></app-in-progress-animation>
  </ng-template>
</ion-content>
@if (showProceedCta()) {
<ion-footer class="ion-no-border">
  <ion-button
    [disabled]="proceedNavigating"
    class="proceed-btn"
    (click)="showTimerError ? loaderGoToSyndicateTab() : goToSyndicateTab()">
    {{ showTimerError ? ("syndicate-tickets.Back_to"|translate) : ("syndicate-tickets.Proceed" | translate)
    }}</ion-button>
</ion-footer>
}
@if (showLoader()) {
<div class="loader-overlay">
  <div class="loader-animation">
    <p class="loading-text">{{'syndicate-loading.loading'|translate}}<br> {{'syndicate-loading.please-wait'|translate}}
    </p>
    <ng-lottie width="70%" class="loader-wrapper" [options]="loaderOptions"></ng-lottie>
  </div>
</div>
}
<!-- Progress bar only while loading — never alongside Proceed CTA -->
@if (showProgressBar && isLoadingUiActive()) {
<div class="progressbar-wrapper">
  <mat-progress-bar class="timer-progress-bar" mode="determinate" [value]="progressSignal() * 2"></mat-progress-bar>
</div>
}
